import styled from '@emotion/styled';

export const SnackbarInfoClickableText = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;
